import script from "./RightFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./RightFooter.vue?vue&type=script&setup=true&lang=js"

import "./RightFooter.vue?vue&type=style&index=0&id=ff03d000&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff03d000"]])

export default __exports__